import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import { MemberType } from "components/Dashboard/DoctorDashboard/group-practice/types/types";

export interface TeamDetails {
  id: string;
  name: string;
  members: MemberType[];
}

export default async function getTeamDetailsById(
  teamId: string,
): Promise<TeamDetails> {
  const res = await fetchOrchidAPI(`/api/users/v1/team/${teamId}`);

  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
